import { render, staticRenderFns } from "./BackHeader.vue?vue&type=template&id=5b3ecf85&"
import script from "./BackHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./BackHeader.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports